import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosClient, { axiosWithAuth } from '@/services/axios';
import { buildQueryString } from '@/utils/string';

const REQUEST_HEADERS = {
  'Content-Type': 'application/json',
  // 'Cache-Control': 'no-cache, no-store, must-revalidate',
  // 'Pragma': 'no-cache',
  // 'Expires': '0'
};

// Async Thunk to Fetch User Profile specific order list
export const fetchOrderList = createAsyncThunk(
  'order/getOrder',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { filters, page, limit, type } = getState().orders;

      const filterObj = {
        page,
        limit,
        ...filters,
        type,
      };
      const url = `/api/order/getAll${buildQueryString(filterObj)}`;
      const response = await axiosWithAuth().get(url);
      return response?.data?.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

// Async Thunk to Fetch User Profile specific past order list
export const fetchPastOrderList = createAsyncThunk(
  'order/getPastOrder',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { filters, page, limit, type } = getState().orders;

      const filterObj = {
        page,
        limit,
        ...filters,
        type: 'canceled',
      };
      const url = `/api/order/getAll${buildQueryString(filterObj)}`;
      const response = await axiosWithAuth().get(url);
      return response?.data?.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const fetchSpecificOrderList = createAsyncThunk(
  'order/getSpecificOrder',
  async ({ id }, { _, rejectWithValue }) => {
    try {
      const url = `/api/order/${id}`;
      const response = await axiosWithAuth().get(url);
      return response?.data?.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const fetchGuestOrderDetails = createAsyncThunk(
  'order/details',
  async ({ orderID, phone }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(`/api/order/details`, {
        order_id: orderID,
        phone,
      });
      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const deleteSpecificOrder = createAsyncThunk(
  'order/delete',
  async ({ orderID, comments }, { getState, dispatch, rejectWithValue }) => {
    // TODO: SHOULD BE REMOVED. THIS IS THE USER ID FOR AUTHENTICATED USER
    // REQUEST_HEADERS['X-User-Id'] = 84;
    try {
      const response = await axiosWithAuth().post(
        `/api/order-cancel/${orderID}`,
        {
          comments,
        },
        // { headers: REQUEST_HEADERS },
      );
      setTimeout(() => dispatch(fetchPastOrderList()), 600);
      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const defaultTemp = () => {};
